import { Navigate, Route, Routes } from 'react-router-dom';
import { OverviewPage } from './overview-page';

export function OrgAdminRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<OverviewPage />} />
      {/* Departments / Practitioners / Access Control land in Sprint 2. */}
      <Route path="*" element={<Navigate to="overview" replace />} />
    </Routes>
  );
}
